import { useEffect, useState } from "react";
import { getHomePageInfos } from "./apiClient";
import { persistManualCorrectionFlag, readManualCorrectionFlag } from "./manualCorrection";

const POLL_MS = 5000;

/**
 * Keeps the manual-correction warning in sync while a page stays open.
 * Home-page info is cached for 30 minutes, so a normal load would keep a
 * stale flag after the admin turns automatic correction on or off.
 */
export default function useManualCorrectionEnabled() {
  const [enabled, setEnabled] = useState(readManualCorrectionFlag);

  useEffect(() => {
    let cancelled = false;

    const refresh = async () => {
      try {
        const response = await getHomePageInfos({
          body: { MANUAL_CORRECTION_ONLY: true },
          forceRefresh: true,
        });
        const payload = response?.decryptedData || response?.data;
        const next = persistManualCorrectionFlag(payload);
        if (!cancelled && next !== null) {
          setEnabled(next);
        }
      } catch (_) {}
    };

    refresh();
    const timer = window.setInterval(() => {
      if (document.visibilityState === "visible") {
        refresh();
      }
    }, POLL_MS);

    const onVisible = () => {
      if (document.visibilityState === "visible") {
        refresh();
      }
    };
    document.addEventListener("visibilitychange", onVisible);

    return () => {
      cancelled = true;
      window.clearInterval(timer);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, []);

  return enabled;
}
